// Sanjay // - 25/01/25
import { axiosGetAuthorize, axiosPostAuthorize } from '../AxiosRequests';
import {
    ProcSelectAllRecordsSP,
    ProcSelectAllRecord2GridviewSP,
    USP_Master_PartyAccountSelect,
    USP_Master_PaymentModeSelect,
    USP_Master_BankSelect,
    USP_Master_PartyAccountSelectOutstandingAmt,
    USP_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake,
    USP_Master_ChequeBookNoSelectbyChequeBookSeries,
    USP_Transaction_PaymentMakeInsertAndUpdate,
    USP_Transaction_PaymentRecvCount,
    USP_Transaction_PaymentRecvInsertUpdate,
    USP_Transaction_ExpenseCount,
    USP_Master_EmployeeSelect,
    USP_Master_ChequeBookSeriesSelectbyBank_ForEmployeeExpense,
    USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForExpenseEntry,
    USP_Master_GeneralProductSelect,
    USP_Transaction_ExpenseInsertAndUpdate,
    USP_Transaction_PaymentMakeSelectbyId,
    USP_Transaction_PaymentRecvSelectbyId,
    USP_Transaction_ExpenseSelectbyId,
    USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForCashWithdraw,
    USP_Transaction_CashWithdrawCount,
    USP_Transaction_CashWithdrawInsertAndUpdate,
    USP_Transaction_CashWithdrawSelectbyId,
    USP_Transaction_GeneralPurchaseCount,
    USP_Extra_NetworkConfigurationSelect,
    USP_Master_PartyAccountSelectGeneral,
    USP_Master_UnitSelect,
    USP_Master_TaxStructureSelect,
    USP_Extra_GatePassSelect_ForGeneralPurchase,
    USP_Master_PartyAccountSelectbyID,
    USP_Master_GeneralProductSelectbyID,
    USP_Master_TaxStructureSelectbyID,
    USP_Transaction_GeneralPurchaseInsert,
    USP_Extra_PrefixSelectPrefix,
    UploadFile,
    USP_Transaction_GeneralPurchaseSelectbyId,
    USP_Master_EmployeeSelect_WithNewChanges,
    USP_Master_SelectedExpenseByList,
    USP_Transaction_AddCashOrAdvanceCount,
    USP_Transaction_AddCashOrAdvanceAddUpdate,
    USP_Transaction_AddCashOrAdvanceSelectbyId,
    USP_Transaction_BankToBankTransferCount,
    GetChequeBookNoSelectbyChequeBookSeriesForBankToBank,
    USP_Transaction_BankToBankTransferSelectbyID,
    BankToBankTransferAddUpdate,
    USP_Transaction_JournalVoucherCOUNT,
    USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForJournalVoucher,
    USP_Transaction_JournalVoucherInsertUpdate,
    USP_Transaction_JournalVoucherSelectbyID,
    USP_Transaction_CreditNoteCount,
    USP_Transaction_CreditNoteInsertUpdate,
    USP_Transaction_CreditNoteSelectById,
    USP_Transaction_DebitNoteCount,
    USP_Transaction_DebitNoteSelectById,
    USP_Transaction_DebitNoteInsertUpdate,
    USP_Master_PurchaseInwardSelectbyIDPartyFor_DebitNote,
    GetEmployeeSalaryDropdown,
    USP_Master_EmployeeSelectbyID_ForSalry,
    USP_Transaction_EmployeeSalaryStructuredInsertUpdate,
    GetTransactionEmployeeSalaryByID,
    GetTransactionEmployeeSalaryDetailsByID,
    GetSalaryToBankDropdown,
    USP_Master_ChequeBookForCompanyToBankTransfer,
    USP_Transaction_CompanyToBankTransferSelectbyID,
    USP_Transaction_CompanyToBankTransferDetailsSelectbyID,
    USP_Transaction_CompanyToBankTransferInsertUpdate,
    USP_GetAllUsers,
} from '../ApiEndPoints';

export default class AccountTransactionServices {

    // async getMasterCompanyList(request) {
    //     return axiosGet(GetMasterCompanyList, request);
    // }
    async procSelectAllRecordsSP(request) {
        return axiosPostAuthorize(ProcSelectAllRecordsSP, request);
    }
    async procSelectAllRecord2GridviewSP(request) {
        return axiosPostAuthorize(ProcSelectAllRecord2GridviewSP, request);
    }
    async usp_Master_PartyAccountSelect(request) {
        return axiosGetAuthorize(USP_Master_PartyAccountSelect, request);
    }
    async usp_Master_PaymentModeSelect(request) {
        return axiosGetAuthorize(USP_Master_PaymentModeSelect, request);
    }
    async usp_Master_BankSelect(request) {
        return axiosGetAuthorize(USP_Master_BankSelect, request);
    }
    async usp_Transaction_PaymentRecvCount(request) {
        return axiosPostAuthorize(USP_Transaction_PaymentRecvCount, request);
    }
    async usp_Master_PartyAccountSelectOutstandingAmt(request) {
        return axiosPostAuthorize(USP_Master_PartyAccountSelectOutstandingAmt, request);
    }
    async usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(request) {
        return axiosPostAuthorize(USP_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake, request);
    }
    async usp_Master_ChequeBookNoSelectbyChequeBookSeries(request) {
        return axiosPostAuthorize(USP_Master_ChequeBookNoSelectbyChequeBookSeries, request);
    }
    async usp_Transaction_PaymentMakeInsertAndUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_PaymentMakeInsertAndUpdate, request);
    }
    async usp_Transaction_PaymentRecvInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_PaymentRecvInsertUpdate, request);
    }
    async usp_Transaction_ExpenseCount(request) {
        return axiosPostAuthorize(USP_Transaction_ExpenseCount, request);
    }
    async usp_Master_EmployeeSelect(request) {
        return axiosGetAuthorize(USP_Master_EmployeeSelect, request);
    }
    async usp_Master_EmployeeSelect_WithNewChanges(request) {
        return axiosGetAuthorize(USP_Master_EmployeeSelect_WithNewChanges, request);
    }
    async usp_Master_ChequeBookSeriesSelectbyBank_ForEmployeeExpense(request) {
        return axiosPostAuthorize(USP_Master_ChequeBookSeriesSelectbyBank_ForEmployeeExpense, request);
    }
    async usp_Master_ChequeBookNoSelectbyChequeBookSeries_ForExpenseEntry(request) {
        return axiosPostAuthorize(USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForExpenseEntry, request);
    }
    async usp_Master_GeneralProductSelect(request) {
        return axiosGetAuthorize(USP_Master_GeneralProductSelect, request);
    }
    // async usp_Master_GeneralProductSelect_WithNewChanges(request) {
    //     return axiosGetAuthorize(USP_Master_GeneralProductSelect_WithNewChanges, request);
    // }
    async usp_Transaction_ExpenseInsertAndUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_ExpenseInsertAndUpdate, request);
    }
    async usp_Transaction_PaymentMakeSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_PaymentMakeSelectbyId, request);
    }
    async usp_Transaction_PaymentRecvSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_PaymentRecvSelectbyId, request);
    }
    async usp_Transaction_ExpenseSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_ExpenseSelectbyId, request);
    }
    async usp_Master_ChequeBookNoSelectbyChequeBookSeries_ForCashWithdraw(request) {
        return axiosPostAuthorize(USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForCashWithdraw, request);
    }
    async usp_Transaction_CashWithdrawCount(request) {
        return axiosGetAuthorize(USP_Transaction_CashWithdrawCount, request);
    }
    async usp_Transaction_CashWithdrawInsertAndUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_CashWithdrawInsertAndUpdate, request);
    }
    async usp_Transaction_CashWithdrawSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_CashWithdrawSelectbyId, request);
    }
    async usp_GetAllUsers() {
        return axiosGetAuthorize(USP_GetAllUsers);
    }

    // General Purchase 
    async getInwardNoCount(request) {
        return axiosGetAuthorize(USP_Transaction_GeneralPurchaseCount, request);
    }
    async getNetworkConfiguration(request) {
        return axiosGetAuthorize(USP_Extra_NetworkConfigurationSelect, request);
    }
    async getPartyAccountGeneral(request) {
        return axiosGetAuthorize(USP_Master_PartyAccountSelectGeneral, request);
    }
    async getUnit(request) {
        return axiosGetAuthorize(USP_Master_UnitSelect, request);
    }
    async getTaxStructure(request) {
        return axiosGetAuthorize(USP_Master_TaxStructureSelect, request);
    }
    async getGatePass(request) {
        return axiosPostAuthorize(USP_Extra_GatePassSelect_ForGeneralPurchase, request);
    }
    async getGeneralProduct(request) {
        return axiosGetAuthorize(USP_Master_GeneralProductSelect, request);
    }
    async getPartyAccountSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_PartyAccountSelectbyID, request);
    }
    async getGeneralProductSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_GeneralProductSelectbyID, request);
    }
    async getTaxStructureSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_TaxStructureSelectbyID, request);
    }
    async submitGeneralPurchase(request) {
        return axiosPostAuthorize(USP_Transaction_GeneralPurchaseInsert, request);
    }
    async getPrefixSelectPrefix(request) {
        return axiosPostAuthorize(USP_Extra_PrefixSelectPrefix, request);
    }
    async uploadFile(request) {
        return axiosPostAuthorize(UploadFile, request);
    }
    async getTransaction_GeneralPurchaseSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_GeneralPurchaseSelectbyId, request);
    }
    async getSelectedExpenseByList(request) {
        return axiosPostAuthorize(USP_Master_SelectedExpenseByList, request);
    }
    async getTransaction_AddCashOrAdvanceCount(request) {
        return axiosPostAuthorize(USP_Transaction_AddCashOrAdvanceCount, request);
    }
    async submitAddCashOrAdvanceAddUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_AddCashOrAdvanceAddUpdate, request);
    }
    async getAddCashOrAdvanceSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_AddCashOrAdvanceSelectbyId, request);
    }
    async getBankToBankTransferCount(request) {
        return axiosPostAuthorize(USP_Transaction_BankToBankTransferCount, request);
    }
    async getChequeBookNoSelectbyChequeBookSeriesForBankToBank(request) {
        return axiosPostAuthorize(GetChequeBookNoSelectbyChequeBookSeriesForBankToBank, request);
    }
    async getBankToBankTransferSelectbyID(request) {
        return axiosGetAuthorize(USP_Transaction_BankToBankTransferSelectbyID, request);
    }
    async bankToBankTransferAddUpdate(request) {
        return axiosPostAuthorize(BankToBankTransferAddUpdate, request);
    }

    // journal voucher 

    async getJournalVoucherCOUNT(request) {
        return axiosPostAuthorize(USP_Transaction_JournalVoucherCOUNT, request);
    }
    async getChequeBookNoSelectbyChequeBookSeries_ForJournalVoucher(request) {
        return axiosPostAuthorize(USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForJournalVoucher, request);
    }
    async submitJournalVoucher(request) {
        return axiosPostAuthorize(USP_Transaction_JournalVoucherInsertUpdate, request);
    }
    async getJournalVoucherSelectbyID(request) {
        return axiosGetAuthorize(USP_Transaction_JournalVoucherSelectbyID, request);
    }

    // credit note 
    async getTransaction_CreditNoteCount(request) {
        return axiosPostAuthorize(USP_Transaction_CreditNoteCount, request);
    }
    async submitCreditNote(request) {
        return axiosPostAuthorize(USP_Transaction_CreditNoteInsertUpdate, request);
    }
    async getCreditNoteSelectById(request) {
        return axiosGetAuthorize(USP_Transaction_CreditNoteSelectById, request);
    }

    // debit note 
    async getDebitNoteCount(request) {
        return axiosPostAuthorize(USP_Transaction_DebitNoteCount, request);
    }
    async submitDebitNote(request) {
        return axiosPostAuthorize(USP_Transaction_DebitNoteInsertUpdate, request);
    }
    async getDebitNoteSelectById(request) {
        return axiosGetAuthorize(USP_Transaction_DebitNoteSelectById, request);
    }
    async getPurchaseInwardSelectbyIDPartyFor_DebitNote(request) {
        return axiosPostAuthorize(USP_Master_PurchaseInwardSelectbyIDPartyFor_DebitNote, request);
    }

    // Employee salary 
    async getEmployeeSalaryDropdown(request) {
        return axiosPostAuthorize(GetEmployeeSalaryDropdown, request);
    }
    async getMasterEmployeeSelectbyIDForSalry(request) {
        return axiosGetAuthorize(USP_Master_EmployeeSelectbyID_ForSalry, request);
    }
    async submitEmployeeSalaryStructuredInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_EmployeeSalaryStructuredInsertUpdate, request);
    }
    async getTransactionEmployeeSalaryByID(request) {
        return axiosGetAuthorize(GetTransactionEmployeeSalaryByID, request);
    }
    async getTransactionEmployeeSalaryDetailsByID(request) {
        return axiosGetAuthorize(GetTransactionEmployeeSalaryDetailsByID, request);
    }

    // Salary to bank
    async getSalaryToBankDropdown(request) {
        return axiosPostAuthorize(GetSalaryToBankDropdown, request);
    }
    async usp_Master_ChequeBookForCompanyToBankTransfer(request) {
        return axiosPostAuthorize(USP_Master_ChequeBookForCompanyToBankTransfer, request);
    }
    async getTransaction_CompanyToBankTransferSelectbyID(request) {
        return axiosGetAuthorize(USP_Transaction_CompanyToBankTransferSelectbyID, request);
    }
    async getTransaction_CompanyToBankTransferDetailsSelectbyID(request) {
        return axiosGetAuthorize(USP_Transaction_CompanyToBankTransferDetailsSelectbyID, request);
    }
    async getTransaction_CompanyToBankTransferInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_CompanyToBankTransferInsertUpdate, request);
    }
}